// Exact labels downloaded from the era table. Hierarchy and ordering remain
// database-driven, while this map keeps display labels available synchronously.
const eraLabels = {
  'advanced late hillfort period': 'Advanced late hillfort period',
  'advanced middle hillfort period': 'Advanced middle hillfort period',
  aurignacian: 'Aurignacian',
  'baden culture': 'Baden culture',
  'bell beaker culture': 'Bell beaker culture',
  'billendorf culture': 'Billendorf culture',
  'billendorf culture (hac)': 'Billendorf culture (HaC)',
  'bohemian-palatinate tumulus culture': 'Bohemian-Palatinate tumulus culture',
  bohunician: 'Bohunician',
  'bošáca group': 'Bošáca group',
  'bronze age': 'Bronze age',
  'bronze age - hallstatt period general':
    'Bronze age - hallstatt period general',
  'bronze age general': 'Bronze age general',
  'bronze age-hallstatt period': 'Bronze age-Hallstatt period',
  'bylany culture': 'Bylany culture',
  'cham culture': 'Cham culture',
  'cheb culture': 'Cheb culture',
  'chlopice-veselé culture': 'Chlopice-Veselé culture',
  'corded ware culture': 'Corded ware culture',
  'dobrodzień group': 'Dobrodzień group',
  'early - high middle ages transition': 'Early - High middle ages transition',
  'early bronze age': 'Early bronze age',
  'early eneolithic': 'Early eneolithic',
  'early hallstatt period (hac-d1)': 'Early Hallstatt period (HaC-D1)',
  'early la tène period': 'Early La Tène period',
  'early late hillfort period': 'Early late hillfort period',
  'early middle ages': 'Early middle ages',
  'early middle ages 1': 'Early middle ages 1',
  'early middle ages 2': 'Early middle ages 2',
  'early middle ages 2-4': 'Early middle ages 2-4',
  'early middle ages 3': 'Early middle ages 3',
  'early middle ages 4': 'Early middle ages 4',
  'early middle ages general': 'Early middle ages general',
  'early middle hillfort period': 'Early middle hillfort period',
  'early migration period': 'Early migration period',
  'early neolithic': 'Early neolithic',
  'early roman age': 'Early roman age',
  eneolithic: 'Eneolithic',
  'eneolithic general': 'Eneolithic general',
  epigravettian: 'Epigravettian',
  epimagdalenian: 'Epimagdalenian',
  'farming prehistory': 'Farming prehistory',
  'farming prehistory general': 'Farming prehistory general',
  'final bronze age': 'Final bronze age',
  'final la tène period (ltd)': 'Final La Tène period (LtD)',
  'funnel beaker culture': 'Funnel beaker culture',
  'globular amphora culture': 'Globular amphora culture',
  gravettian: 'Gravettian',
  'had-lta period': 'HAD-LTA period',
  'hallstatt - la tène period': 'Hallstatt - La Tène period',
  'hallstatt period': 'Hallstatt period',
  'hallstatt period general': 'Hallstatt period general',
  'hallstatt tumulus culture': 'Hallstatt tumulus culture',
  'hallstatt-la tène period general': 'Hallstatt-La Tène period general',
  'hatvan culture': 'Hatvan Culture',
  'high - late middle ages': 'High - Late middle ages',
  'high - late middle ages general': 'High - Late middle ages general',
  'high middle ages': 'High middle ages',
  'high middle ages - modern period': 'High middle ages - Modern period',
  'high middle ages - modern period general':
    'High middle ages - Modern period general',
  'horákov culture': 'Horákov culture',
  'indeterminate dating': 'Indeterminate dating',
  'industrial period': 'Industrial period',
  'industrial period 1': 'Industrial Period 1',
  'industrial period 2': 'Industrial Period 2',
  'industrial period general': 'Industrial Period general',
  'jevišovice culture': 'Jevišovice culture',
  'jordanów culture': 'Jordanów culture',
  'knovíz culture': 'Knovíz culture',
  'kobyly group': 'Kobyly group',
  'kosihy-čaka culture': 'Kosihy-Čaka culture',
  krumlovien: 'Krumlovien',
  'la tène period': 'La Tène period',
  'la tène period - roman age': 'La Tène period - Roman age',
  'la tène period general': 'La Tène period general',
  'la tène-roman age general': 'La Tène-Roman age general',
  'late - final eneolithic': 'Late - Final eneolithic',
  'late bronze age': 'Late bronze age',
  'late eneolithic': 'Late eneolithic',
  'late hallstatt period (had2-3)': 'Late Hallstatt period (HaD2-3)',
  'late hillfort period': 'Late hillfort period',
  'late middle ages': 'Late middle ages',
  'late middle ages - modern period transition':
    'Late middle ages - Modern period transition',
  'late middle hillfort period': 'Late middle hillfort period',
  'late migration period': 'Late migration period',
  'late paleolithic': 'Late paleolithic',
  'late roman age': 'Late roman age',
  'late/final la tène period (ltc2-d)': 'Late/Final La Tène period (LtC2-D)',
  'lengyel culture': 'Lengyel culture',
  'linear pottery culture': 'Linear pottery culture',
  'lower paleolithic': 'Lower paleolithic',
  'lusatian culture': 'Lusatian culture',
  magdalenian: 'Magdalenian',
  mesolithic: 'Mesolithic',
  'mesolithic general': 'Mesolithic general',
  'michelsberg culture': 'Michelsberg culture',
  micoquian: 'Micoquian',
  'middle / late neolithic': 'Middle / Late neolithic',
  'middle ages': 'Middle ages',
  'middle ages - modern period': 'Middle ages - Modern period',
  'middle ages - modern period general': 'Middle ages - Modern period general',
  'middle ages general': 'Middle ages general',
  'middle bronze age': 'Middle bronze age',
  'middle eneolithic': 'Middle eneolithic',
  'middle la tène period (ltb-c1)': 'Middle La Tène period (LtB-C1)',
  'middle paleolithic': 'Middle paleolithic',
  'middle to late la tène period (ltc1-2)':
    'Middle to late La Tène period (ltc1-2)',
  'middle-danubian tumulus culture': 'Middle-Danubian tumulus culture',
  'migration period': 'Migration period',
  'migration period general': 'Migration period general',
  'milavče culture': 'Milavče culture',
  'modern - industrial period': 'Modern - Industrial period',
  'modern - industrial period general': 'Modern - Industrial period general',
  'modern period': 'Modern period',
  'modern period 1': 'Modern period 1',
  'modern period 2': 'Modern period 2',
  'modern period general': 'Modern period general',
  'moravian painted ware culture (eneolithic)':
    'Moravian painted ware culture (eneolithic)',
  'moravian painted ware culture (neolithic)':
    'Moravian painted ware culture (neolithic)',
  mousterian: 'Mousterian',
  'míškovice type': 'Míškovice type',
  'münchshofen culture': 'Münchshofen culture',
  neolithic: 'Neolithic',
  'neolithic - eneolithic general': 'Neolithic - Eneolithic general',
  'neolithic general': 'Neolithic general',
  'neolithic-eneolithic': 'Neolithic-Eneolithic',
  'nitra culture': 'Nitra culture',
  'nynice culture': 'Nynice culture',
  'oberlauterbach culture': 'Oberlauterbach culture',
  'ohrozim type': 'Ohrozim type',
  'ostroměř group': 'Ostroměř Group',
  paleolithic: 'Paleolithic',
  'paleolithic general': 'Paleolithic general',
  'paleolithic-mesolithic': 'Paleolithic-Mesolithic',
  'paleolithic-mesolithic general': 'Paleolithic-Mesolithic general',
  prehistory: 'Prehistory',
  'platěnice culture': 'Platěnice culture',
  'plaňany type': 'Plaňany type',
  'podmokly group': 'Podmokly group',
  'podolí culture': 'Podolí culture',
  'prehistory general': 'Prehistory general',
  'proto-eneolithic': 'Proto-eneolithic',
  'proto-únětice culture': 'Proto-Únětice culture',
  'przeworsk culture': 'Przeworsk culture',
  'púchov culture': 'Púchov culture',
  'retz-bajč-křepice culture': 'Retz-Bajč-Křepice culture',
  'roman age': 'Roman age',
  'roman age - migration period': 'Roman age - Migration period',
  'roman age - migration period general':
    'Roman age - Migration period general',
  'roman age general': 'Roman age general',
  'saxonian-lusatian culture': 'Saxonian-Lusatian culture',
  'schussenried culture': 'Schussenried culture',
  'silesian culture': 'Silesian culture',
  'silesian-platěnice culture': 'Silesian-Platěnice culture',
  'silesian-platěnice culture (hab)': 'Silesian-Platěnice culture (HaB)',
  'silesian-platěnice culture (hac-d)': 'Silesian-Platěnice culture (HaC-D)',
  'stroke pottery culture': 'Stroke pottery culture',
  szeletian: 'Szeletian',
  taubachian: 'Taubachian',
  'turnov type': 'Turnov type',
  'upper paleolithic': 'Upper paleolithic',
  'urnfield period': 'Urnfield period',
  'velatice culture': 'Velatice culture',
  'věteřov culture': 'Věteřov culture',
  'únětice culture': 'Únětice culture',
  'řivnáč culture': 'Řivnáč culture',
  'štítary culture': 'Štítary culture',
  'šárka type': 'Šárka type',
  'želizovce group': 'Želizovce group',
} as const;

type EraId = keyof typeof eraLabels;

const eraIds = Object.keys(eraLabels) as EraId[];

function getEraLabel(value?: string | null): string {
  if (!value) {
    return '';
  }

  return eraLabels[value.toLocaleLowerCase() as EraId] || value;
}

export { eraIds, eraLabels, getEraLabel };
export type { EraId };
